import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCrown,
  faXmark,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../AuthContext';

import './PremiumButton.css';
import conti from '../imagesHome/conti.png';
const apiUrl = process.env.REACT_APP_API_URL;

const PremiumButton = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const [showPremiumPopup, setShowPremiumPopup] = useState(false);

  const [isPremium, setIsPremium] = useState(
    auth?.user?.is_premium === true
  );

  // Verifica statusul Premium imediat dupa montarea componentei
  useEffect(() => {
    let cancelled = false;

    const fetchPremiumStatus = async () => {
      try {
        const response = await fetch(`${apiUrl}/user`, {
          method: 'GET',
          credentials: 'include'
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();

        if (!cancelled) {
          setIsPremium(data?.is_premium === true);
        }
      } catch (error) {
        console.error(
          'Eroare la verificarea statusului Premium:',
          error
        );
      }
    };

    fetchPremiumStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  // Daca AuthContext se actualizeaza dupa login/plata,
  // actualizam imediat si butonul
  useEffect(() => {
    if (typeof auth?.user?.is_premium === 'boolean') {
      setIsPremium(auth.user.is_premium);
    }
  }, [auth?.user?.is_premium]);

  const label = isPremium
    ? 'Premium activ'
    : 'Treci la Premium';

  const handleClick = () => {
    if (isPremium) {
      navigate('/premium');
      return;
    }

    setShowPremiumPopup(true);
  };

  const closePopup = () => {
    setShowPremiumPopup(false);
  };

const handleViewPlans = () => {
  setShowPremiumPopup(false);
  navigate('/premium/plans');
};

  return (
    <>
      <button
        type="button"
        className={`pm-topbar-btn ${
          isPremium ? 'is-premium' : 'is-free'
        }`}
        onClick={handleClick}
        aria-label={label}
        title={label}
      >
        <FontAwesomeIcon
          icon={faCrown}
          className="pm-topbar-icon"
          aria-hidden="true"
        />
      </button>

      {showPremiumPopup && (
        <div
          className="premium-popup-overlay"
          onClick={closePopup}
        >
          <div
            className="premium-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="premium-popup-close"
              onClick={closePopup}
              aria-label="Inchide"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>

            <div className="premium-popup-header">
              
<div className="premium-popup-crown">
  <img
    src={conti}
    alt="Conti"
    className="premium-popup-conti"
  />
</div>


              <h2>Descopera ContaLearn Premium</h2>

              <p>
                Acces complet la ContaLearn si toate
                functionalitatile Premium.
              </p>
            </div>

            <div className="premium-popup-benefits">
              <div className="premium-popup-benefit">
                <FontAwesomeIcon icon={faCheck} />
                <span>Acces la cursurile premium</span>
              </div>

              <div className="premium-popup-benefit">
                <FontAwesomeIcon icon={faCheck} />
                <span>Vieti nelimitate</span>
              </div>

              <div className="premium-popup-benefit">
                <FontAwesomeIcon icon={faCheck} />
                <span>Toate modulele deblocate</span>
              </div>

             
            </div>

            <div className="premium-popup-footer">
              <button
                type="button"
                className="premium-popup-action"
                onClick={handleViewPlans}
              >
                Vezi planul Premium
              </button>

              <button
                type="button"
                className="premium-popup-later"
                onClick={closePopup}
              >
                Poate mai tarziu
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PremiumButton;